import { Barcode as BarcodeIcon } from '@cheqroom/icons';
import { FC } from 'react';

import { Info } from '../Info';

export interface BarcodeProps {
	barcodes: string[];
}

export const Barcode: FC<BarcodeProps> = ({ barcodes }) => {
	if (!barcodes.length) return null;

	return <Info icon={BarcodeIcon} text={barcodes[0]} />;
};
